import { combineReducers } from "redux";
import user from "./user";
import loading from "./loading";
import firebase from './firebase';
import states from './states';

export default combineReducers({
  user,
  loading,
  firebase,
  states
});